import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import JsBarcode from "jsbarcode";
import "../components/Blog.css";
import {useLocation} from 'react-router-dom';


const BlogDetails = () => {

   const [barcodeText, setBarcodeText] = useState("");
  const barcodeRef = useRef(null);
  const [showDownload, setShowDownload] = useState(false);
   const location = useLocation();
    const [title, setTitle] = useState({});

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  // json viewer tool
  const generateBarcode = (e) => {
    e.preventDefault();
    if (!barcodeText) return;

    JsBarcode(barcodeRef.current, barcodeText, {
      format: "CODE128",
      width: 2,
      height: 50,
      displayValue: true,
    });
    setShowDownload(true);
  };

 const downloadBarcode = () => {
    const svgData = new XMLSerializer().serializeToString(barcodeRef.current);
    const blob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
   

    

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${barcodeText}_barcode.svg`;
    a.click();
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                CodeInputs - Barcode Generator
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

              
       <p className="mt-4">
            Unlock the power of effortless barcode creation with our Free Barcode Generator. Whether you need a quick barcode for inventory management, product labeling, or any other application, our intuitive barcode tool for free ensures you get the job done swiftly and accurately. Generate high-quality barcodes in seconds with our user-friendly interface—no cost, no hassle. Experience the convenience of a quick barcode solution that meets all your business needs without the need for expensive software. Try it now and streamline your barcode generation process effortlessly!
          </p>
          <Form onSubmit={generateBarcode} className="mt-3">
            <Form.Group>
              <Form.Label>Enter Text for Barcode:</Form.Label>
              <Form.Control
                type="text"
                value={barcodeText}
                onChange={(e) => setBarcodeText(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3">
              Generate Barcode
            </Button>
          </Form>
          <div className="mt-4">
            <svg ref={barcodeRef}></svg>
          </div>
          {showDownload && (
            <Button
              variant="warning"
              className="mt-3"
              onClick={downloadBarcode}
            >
              Download Barcode
            </Button>
          )}
          </div>
        </div>

             {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
